<template>
  <!-- 통계 카운터 편집 드로어 -->
  <a-drawer
    :visible="isVisible"
    title="통계 섹션 편집"
    placement="right"
    :width="drawerWidth"
    :destroy-on-close="false"
    @close="handleClose"
  >
    <div v-if="statsData" class="stats-editor">
      <!-- 3개 통계 항목 편집 -->
      <div
        v-for="(stat, idx) in statsList"
        :key="idx"
        class="stats-editor__item"
      >
        <div class="stats-editor__item-title">통계 {{ idx + 1 }}</div>

        <!-- 수치 값 -->
        <div class="stats-editor__field">
          <label class="stats-editor__label">수치</label>
          <a-input-number
            :value="stat.value"
            :min="0"
            style="width: 100%"
            placeholder="숫자를 입력하세요"
            @change="(val) => updateStat(idx, 'value', val)"
          />
        </div>

        <!-- 단위 텍스트 -->
        <div class="stats-editor__field">
          <label class="stats-editor__label">단위</label>
          <a-input
            :value="stat.unit"
            placeholder="단위 (예: +, %, 개)"
            @change="(e) => updateStat(idx, 'unit', e.target.value)"
          />
        </div>

        <!-- 라벨 -->
        <div class="stats-editor__field">
          <label class="stats-editor__label">라벨 (최대 15자)</label>
          <a-input
            :value="stat.label"
            :maxlength="15"
            show-count
            placeholder="통계 설명 라벨"
            @change="(e) => updateStat(idx, 'label', e.target.value)"
          />
        </div>
      </div>
    </div>

    <!-- 데이터 미로드 상태 -->
    <div v-else class="stats-editor__empty">
      <a-spin tip="데이터를 불러오는 중..." />
    </div>
  </a-drawer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

// 기본 통계 항목 구조 (3개)
const DEFAULT_STATS = [
  { value: 0, unit: '', label: '' },
  { value: 0, unit: '', label: '' },
  { value: 0, unit: '', label: '' },
];

export default {
  name: 'StatsEditor',

  data() {
    return {
      escHandler: null,
    };
  },

  computed: {
    ...mapState('homepageEditor', ['activeEditor']),
    ...mapGetters('homepageEditor', ['currentPageData']),

    // 드로어 표시 여부
    isVisible() {
      return (
        this.activeEditor?.type === 'drawer' &&
        this.activeEditor?.sectionKey === 'stats'
      );
    },

    // 반응형 드로어 너비
    drawerWidth() {
      return window.innerWidth >= 1440 ? 520 : 420;
    },

    // 현재 stats 섹션 데이터
    statsSection() {
      if (!this.currentPageData?.sections) return null;
      return this.currentPageData.sections.find((s) => s.sectionKey === 'stats');
    },

    // stats 데이터 객체
    statsData() {
      return this.statsSection?.data || null;
    },

    // 통계 항목 배열 (항상 3개 유지)
    statsList() {
      if (!this.statsData?.stats || this.statsData.stats.length === 0) {
        return DEFAULT_STATS;
      }
      const list = [...this.statsData.stats];
      while (list.length < 3) {
        list.push({ value: 0, unit: '', label: '' });
      }
      return list.slice(0, 3);
    },
  },

  watch: {
    isVisible(val) {
      if (val) {
        this.registerEscHandler();
      } else {
        this.removeEscHandler();
      }
    },
  },

  beforeUnmount() {
    this.removeEscHandler();
  },

  methods: {
    handleClose() {
      this.$store.commit('homepageEditor/SET_ACTIVE_EDITOR', null);
    },

    // 특정 통계 항목 필드 업데이트 후 Vuex 즉시 반영
    updateStat(index, field, value) {
      if (!this.statsSection) return;
      const stats = [...this.statsList];
      stats[index] = { ...stats[index], [field]: value };
      const updatedData = { ...this.statsData, stats };
      this.$store.commit('homepageEditor/UPDATE_SECTION', {
        page: 'main',
        sectionKey: 'stats',
        data: updatedData,
      });
    },

    registerEscHandler() {
      this.escHandler = (e) => {
        if (e.key === 'Escape') this.handleClose();
      };
      window.addEventListener('keydown', this.escHandler);
    },

    removeEscHandler() {
      if (this.escHandler) {
        window.removeEventListener('keydown', this.escHandler);
        this.escHandler = null;
      }
    },
  },
};
</script>

<style scoped>
.stats-editor__item {
  padding: 16px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  margin-bottom: 16px;
}

.stats-editor__item-title {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.stats-editor__field {
  margin-bottom: 12px;
}

.stats-editor__label {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  color: #555;
}

.stats-editor__empty {
  text-align: center;
  padding: 40px 0;
}
</style>
